// extracted by mini-css-extract-plugin
export default {"callbackPage":"C4yA58","callbackCard":"mI4JEa","callbackTitle":"p0sqBb","callbackText":"U9bM19","callbackError":"bx3nN0"};